"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToGroup = void 0;
var _react = require("react");
var _index = require("./index");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useToGroup = exports.useToGroup = function useToGroup(_ref) {
  var isGroupFocused = _ref.isGroupFocused,
    onOptionHover = _ref.onOptionHover,
    multiple = _ref.multiple,
    renderGroup = _ref.renderGroup,
    filteredOptions = _ref.filteredOptions,
    groupBy = _ref.groupBy,
    selectedOptions = _ref.selectedOptions,
    onChange = _ref.onChange,
    getOptionValue = _ref.getOptionValue;
  var isGroupIndeterminate = (0, _index.useIsGroupIndeterminate)({
    selectedOptions: selectedOptions,
    filteredOptions: filteredOptions,
    groupBy: groupBy,
    getOptionValue: getOptionValue
  });
  var isGroupSelected = (0, _index.useIsGroupSelected)({
    selectedOptions: selectedOptions,
    filteredOptions: filteredOptions,
    groupBy: groupBy,
    getOptionValue: getOptionValue
  });
  var handleSelectGroup = (0, _react.useCallback)(function (_ref2, _ref3) {
    var groupKey = _ref2.groupKey;
    var selected = _ref3.selected;
    var filteredGroupOptions = filteredOptions.filter(function (el) {
      return el[groupBy] === groupKey;
    });
    var filteredGroupIds = filteredGroupOptions.map(getOptionValue);
    var filteredSelected = selectedOptions.filter(function (opt) {
      return !filteredGroupIds.includes(getOptionValue(opt));
    });
    if (selected) {
      onChange(filteredSelected);
    } else {
      onChange([].concat(_toConsumableArray(filteredSelected), _toConsumableArray(filteredGroupOptions)));
    }
  }, [onChange, selectedOptions, filteredOptions]);
  return (0, _react.useCallback)(function (group, i) {
    var groupKey = group.groupKey;
    var groupId = "group-".concat(i);
    var indeterminate = isGroupIndeterminate(group);
    //not group only visible group
    var selected = isGroupSelected(group);
    var onSelect = function onSelect() {
      return handleSelectGroup(group, {
        selected: selected
      });
    };
    var focused = isGroupFocused(group);
    var onHover = focused ? undefined : function () {
      return onOptionHover(group);
    };
    return {
      type: 'group',
      key: groupId,
      data: group,
      isButton: multiple,
      selected: selected,
      focused: focused,
      disabled: group === null || group === void 0 ? void 0 : group.disabled,
      render: function render() {
        return renderGroup ? renderGroup({
          groupKey: groupKey
        }, {
          selected: selected,
          indeterminate: indeterminate
        }) : groupKey;
      },
      innerProps: {
        id: groupId,
        onClick: multiple ? onSelect : null,
        onMouseMove: multiple ? onHover : null,
        onMouseOver: multiple ? onHover : null,
        tabIndex: group !== null && group !== void 0 && group.disabled ? null : -1
      }
    };
  }, [filteredOptions, renderGroup, isGroupSelected, isGroupIndeterminate, handleSelectGroup, isGroupFocused, multiple]);
};